<template>
    <el-dialog title="账号操作日志" :visible="isShow" width="70%" :before-close="close">
        <el-form :inline="true" :model="searchModel" ref="searchModel">
            <el-form-item label="用户ID：">
                <el-input v-model="searchModel.user_id" placeholder="请输入用户ID" clearable @keyup.enter.native="submitSearch"></el-input>
            </el-form-item>
            <el-form-item label="用户名：">
                <el-input v-model="searchModel.username" placeholder="请输入用户名" clearable @keyup.enter.native="submitSearch"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button icon="el-icon-search" type="primary" size="small" @click="submitSearch">搜索</el-button>
                <el-button type="default" size="small" @click="resetSearch">重置</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="logs" width="100%">

            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-table :data="props.row.content" width="100%" border size="mini">
                        <el-table-column prop="user_id" label="用户ID"></el-table-column>
                        <el-table-column prop="username" label="用户名"></el-table-column>
                        <el-table-column prop="real_name" label="真实姓名"></el-table-column>
                        <el-table-column prop="is_common" label="是否公用"></el-table-column>
                        <el-table-column prop="identity" label="身份"></el-table-column>
                        <el-table-column prop="bind_subjects" label="绑定学科"></el-table-column>
                        <el-table-column prop="mobile" label="注册手机号"></el-table-column>
                    </el-table>

                </template>
            </el-table-column>
            <el-table-column prop="created_at" label="执行时间" width="200"></el-table-column>
            <el-table-column prop="username" label="操作人" width="200"></el-table-column>
            <el-table-column prop="type_label" label="操作类型" width="200"></el-table-column>
            <el-table-column prop="created_ip" label="执行时IP" width="200"></el-table-column>
            <el-table-column prop="memo" label="备注"></el-table-column>
        </el-table>
        <el-row v-if="page">
            <pagination2 :link-page="page" :enableEvent="true" @change="watchPage"></pagination2>
        </el-row>
    </el-dialog>
</template>

<script>

    import AccountService from "~/services/CustomerAccounts";
    import Pagination2 from "~/widgets/Pagination.vue";


    export default {
        name: "AccountLog",
        components: {
            Pagination2
        },
        props: {
            display: {
                type: Boolean,
                default: false
            },
            customer: {
                type: Object,
                default: null
            }
        },
        watch: {
            display: function (value, origin) {
                this.isShow = value;
            }
        },
        data() {
            return {
                isShow: false,
                logs: [],
                page: null,
                searchModel: {
                    customer_id: '',
                    user_id: '',
                    username: '',
                    perPage: 20,
                    page: 1
                }
            }
        },
        created() {
            this.isShow = this.display;
            if (this.customer.id && this.customer.id > 0) {
                this.searchModel.customer_id = this.customer.id;
            }

            this.getLogs(this.searchModel);

        },
        methods: {


            getLogs(params) {
                AccountService.getChangeLogs(params).then(res => {
                    if  (res && res.code == 0) {
                        this.logs = res.data;
                        if (res._meta) {
                            this.page = res._meta;
                        }
                    }
                })
            },

            submitSearch() {
                this.searchModel.page = 1;
                this.getLogs(this.searchModel);
            },

            resetSearch() {
                this.searchModel.user_id = '';
                this.searchModel.username = '';
                this.searchModel.page = 1;
                this.getLogs(this.searchModel);
            },

            close(status = false) {
                this.isShow = false;
                this.$emit("callback", status);
            },

            watchPage(pageParams) {
                this.searchModel['page'] = pageParams["page"];
                this.searchModel['perPage'] = pageParams["perPage"];
                this.getLogs(this.searchModel);
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/customer/dialog/AccountLog.vue